import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tzdate',
})
export class TzdatePipe implements PipeTransform {
  transform(date: string | null) {
    return date ? date.replace(' ', 'T') : date;
  }
}
